import { Box } from "@mui/material";

interface Props {
  logoUrl?: string;
  title?: string;
}

const PortalLogoMark = ({ logoUrl, title }: Props) => (
  <Box
    component="img"
    src={logoUrl}
    alt={title ?? "Portal logo"}
    sx={(theme) => ({
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
    })}
  />
);

export default PortalLogoMark;
